/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions, mapMutations } from 'vuex';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import GroupTitle from "vux/src/components/group-title/index.vue"; // this line is trasformed by vux-loader
import Confirm from "vux/src/components/confirm/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import UserLogo from '@/components/UserLogo';
import { apiUpdateName, apisystemsettingByCode, getKefuGetUrl, postV2SessionUserUpdateLocale } from '@/api';
import SinglePicker from '@/components/Base/SinglePicker';
import vConsole from 'vconsole';
var clicks = 0; // 点击计数器
var vcon = null;
export default {
  name: 'mine',
  directives: {
    TransferDom: TransferDom
  },
  components: {
    SinglePicker: SinglePicker,
    ViewBox: ViewBox,
    Group: Group,
    Cell: Cell,
    UserLogo: UserLogo,
    GroupTitle: GroupTitle,
    Confirm: Confirm
  },
  data: function data() {
    return {
      i18NList: [{
        name: i18n.tc("503"),
        value: 'zh_CN'
      }, {
        name: 'English',
        value: 'en_GB'
      }],
      isShowI18N: false,
      isShowFaq: 0,
      showModal: false,
      modalVal: '',
      modifyType: ''
    };
  },
  computed: _objectSpread({}, mapState('globalStore', ['user', 'pageReload'])),
  created: function created() {
    var _this = this;
    apisystemsettingByCode({
      code: 40009
    }).then(function (res) {
      if (res.success) {
        _this.isShowFaq = +res.data.value;
      }
    });
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations('globalStore', ['_Authorization'])), mapActions('globalStore', ['_ApiLogout', '_ApiSession'])), {}, {
    handleSetConsole: function handleSetConsole() {
      console.log('AutoConsole: handleSetConsole -> handleSetConsole');
      clicks++;
      if (clicks === 10) {
        vcon = new vConsole();
      }
    },
    setI18N: function setI18N(name) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('AutoConsole: setI18N -> name', name);
                if (!(_this2.$i18n.locale === name)) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                _context.next = 5;
                return postV2SessionUserUpdateLocale({
                  locale: name
                });
              case 5:
                _context.next = 7;
                return _this2._ApiSession();
              case 7:
                setTimeout(function () {
                  window.location.reload(true);
                }, 1000);
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    hanlderKf: function hanlderKf() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                getKefuGetUrl().then(function (res) {
                  if (res.success) {
                    if (process.env.NODE_ENV === 'development') {
                      window.open(res.data, '_blank');
                    } else {
                      window.location.href = res.data;
                    }
                  } else {
                    _this3.$vux.toast.text(res.message || i18n.tc("504"));
                  }
                });
              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onConfirm: function onConfirm(val) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (val) {
                  _context3.next = 3;
                  break;
                }
                _this4.$vux.toast.text(i18n.tc("483"));
                return _context3.abrupt("return");
              case 3:
                _context3.next = 5;
                return apiUpdateName({
                  name: val
                });
              case 5:
                res = _context3.sent;
                if (res.success) {
                  _this4.$vux.toast.text(i18n.tc("484"));
                  _this4.user.name = val;
                  _this4.$store.commit('globalStore/_user', _this4.user);
                } else {
                  _this4.$vux.toast.text(res.message);
                }
              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onHide: function onHide() {
      this.modalVal = '';
    },
    showFun: function showFun(text, val) {
      var _this5 = this;
      this.showModal = true;
      this.modalVal = val;
      this.modifyType = text;
      setTimeout(function (_) {
        _this5.$refs.confirm.setInputValue(val);
      });
    },
    logout: function logout() {
      var _this6 = this;
      this.$vux.confirm.show({
        title: i18n.tc("505"),
        content: i18n.tc("506"),
        hideOnBlur: true,
        onConfirm: function () {
          var _onConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return _this6._ApiLogout();
                  case 2:
                    _this6._Authorization('');
                    _this6.$router.push({
                      name: 'Home'
                    });
                  case 4:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));
          function onConfirm() {
            return _onConfirm.apply(this, arguments);
          }
          return onConfirm;
        }()
      });
    }
  })
};